var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row g-1 justify-content-center"},_vm._l((_vm.data),function(item,index){return _c('div',{key:`pr-b${index}`,staticClass:"col-60 col-lg-15",class:{'col-lg-20': _vm.data.length < 4}},[_c('PricingBox',{attrs:{"data":item,"linklabel":_vm.linklabel,"linkpath":_vm.linkpath}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }